<div class="modal">
    <div class="back-btn" (click)="onCancelClick()"></div>
    <div class="modal-panel">
        <p>{{ data.message | translate }}</p>
        <div class="button-modal-container horizontal-focusable-container data-blocked"  data-blocked>
            <button class="btn focusable-element" [attr.aria-label]=" 'Ok' | translate" tabindex="0" (click)="onActionProceed()">
                {{ 'Ok' | translate }}</button>
        </div>
    </div>
</div>